import styled from '@emotion/styled'

export const FooterActions = styled.footer`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: auto;
`
